module.exports = __webpack_public_path__ + "static/media/keith100.63a95ae4.png";